/**
 * RequisitesAddChoiceModal - Модалка выбора способа добавления реквизитов
 *
 * Предлагает два варианта:
 * 1. Сгенерировать ссылку для внешнего заполнения
 * 2. Заполнить вручную в CRM
 */
import React from 'react';
import {
  Modal,
  UnstyledButton,
  Group,
  Stack,
  Text,
  ThemeIcon,
  Box,
} from '@mantine/core';
import {
  IconLink,
  IconPencil,
  IconChevronRight,
} from '@tabler/icons-react';
import tokens from '../../../theme/designTokens';

const ChoiceCard = ({ icon: Icon, iconColor, title, description, onClick }) => (
  <UnstyledButton
    onClick={onClick}
    style={{
      padding: '16px',
      borderRadius: '12px',
      border: `1px solid ${tokens.colors.neutral[3]}`,
      transition: 'all 150ms ease',
      width: '100%',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = tokens.colors.neutral[1];
      e.currentTarget.style.borderColor = tokens.colors.brand.primary;
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = '';
      e.currentTarget.style.borderColor = tokens.colors.neutral[3];
    }}
  >
    <Group wrap="nowrap">
      <ThemeIcon size={44} radius="xl" color={iconColor} variant="light">
        <Icon size={22} />
      </ThemeIcon>
      <Box style={{ flex: 1 }}>
        <Text fw={500} size="sm">
          {title}
        </Text>
        <Text size="xs" c="dimmed" mt={2}>
          {description}
        </Text>
      </Box>
      <IconChevronRight size={16} color={tokens.colors.neutral[5]} />
    </Group>
  </UnstyledButton>
);

const RequisitesAddChoiceModal = ({
  opened,
  onClose,
  onChooseLink,
  onChooseManual,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Добавить реквизиты"
      size="md"
      radius="xl"
      styles={{
        content: { borderRadius: '16px' },
      }}
    >
      <Stack gap="sm">
        <ChoiceCard
          icon={IconLink}
          iconColor="blue"
          title="Сгенерировать ссылку"
          description="Отправьте ссылку представителю организации для самостоятельного заполнения реквизитов"
          onClick={onChooseLink}
        />
        <ChoiceCard
          icon={IconPencil}
          iconColor="green"
          title="Заполнить вручную"
          description="Заполните реквизиты самостоятельно в форме CRM"
          onClick={onChooseManual}
        />
      </Stack>
    </Modal>
  );
};

export default RequisitesAddChoiceModal;
